export const texts = {
    BARRA: ' / ',
    PESO: ' MB'
}